var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"scene",attrs:{"id":"thanks"}},[_c('div',{staticClass:"static-container"})])}]

export { render, staticRenderFns }